const branding = {
    logo: "/assets/images/common/freshy_logo.png",
    // copyright: `${String.fromCharCode(169)} 2020`
};

const getBranding = () => branding;

export { getBranding };
